import { render, staticRenderFns } from "./Ubuntu.vue?vue&type=template&id=f65a5a32&scoped=true"
import script from "./Ubuntu.vue?vue&type=script&lang=js"
export * from "./Ubuntu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65a5a32",
  null
  
)

export default component.exports